import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const LoginContainer = styled.div`
  flex-direction: column;
  width: 70%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  .inputBox {
    margin-bottom: 0px;
  }
  .ant-modal-header {
    display: none;
  }
  .ant-modal-body {
    padding: 34px;
  }

  .login-logo {
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  .content-body {
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  }
  .forgot-btn {
    animation: ${fadeText} 1.2s ease-in-out 0s forwards;
    margin-bottom:15px;
  }
  .login-btn{
    margin-bottom:15px;
  }
  .footer {
    animation: ${fadeText} 1.8s ease-in-out 0s forwards;

    > p {
      color: grey;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Container = styled.div`
font-size:16px;
background-color: #fff;
height:100vh;
position: absolute;
z-index: 999;
top: 0;
width: 100%;
* {
  vertical-align: unset;
}

.right-side{
  text-align: center;
  display: flex;  
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 67%;
  margin: auto;
}

&.modal {
  height: auto;
  position: static;

  .right-side {
    height: auto;
    width: 100%;

    .redirect-btn {
      display: block !important;
    }
  }

  ${LoginContainer} {
    width: 100%;
    height: auto;

    .redirect-btn {
      display: block !important;
    }
  }
}

.plan{
  font-size:0.8rem;
  animation: ${fadeText} 1.2s ease-in-out 0s forwards; 
  position: relative;
  z-index: 1;
}
.usage{
  font-family:glacial indifference !important ;
  font-size: 1.1rem;
  color: #000000;
  text-align: center;
  animation: ${fadeText} 1.4s ease-in-out 0s forwards; 
}

.content-body{
  margin:15px auto;  
  width:90%   
  animation: ${fadeText} 1.6s ease-in-out 0s forwards; 
  text-align:left;
}

.agree-btn{
  animation: ${fadeText} 1.8s ease-in-out 0s forwards;
  font-family:glacial indifference !important ; 
  p {
    display: inline;
    a {
      display: block;
      padding-left: 8px;
      text-decoration: none;
    }
  }
  .ant-checkbox-inner {
    border-color: #333;
  }
}

.label{
  font-family: 'canva sans';
  font-size: 0.8rem;
  color: #000000;
}
.footer{
  text-align:center;
}
.warning-message{
font-size:18px;
font-family:glacial indifference !important ; 
color:#ff4d4f
}
.not-allowed{
  cursor:not-allowed;
}
.left-side{
    width: 100vw;
    height: 100vh;  
}
.inputBox{
  height:45px;
}
.outter{
  width:100%;
  height:100vh;
  display:flex;
  flex-direction:column;
  justify-content:center;
}

.video-container {
  height: 100%;
  width:100%;  
  position: relative;
  overflow: hidden; 
}

video {
  object-fit: cover; 
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;  
}

.video-container:after {
  content: '';
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(black, .2);
  z-index: 1;
}

.callout{ 
  font-size: 2.1rem;
  font-family:amsterdam one;
  color:#FFFFFF
  position: relative;
  top: 3%; 
  text-align: right;
  right: 5%;
  animation: ${fadeText} 0.8s ease-in-out 0s forwards;
}

.side-button{
  position: absolute;
  top:43%; 
  display:flex;
  flex-direction:column;
  row-gap:5px;
  font-size:1.2rem;
  font-family:glacial indifference;
  left:-5%; 
  z-index:999;
}
.btn{
  cursor: pointer; 
  display:flex;
  align-items:center;
  justify-content: center; 
  width:180px
  height:48px
  border-radius:50px;
}
.login-btn{
  animation: ${fadeText} 1s ease-in-out 0s forwards;
}
.signup-btn{
  animation: ${fadeText} 1.2s ease-in-out 0s forwards;
}
.active{
  background:#FFFFFF;
  color:#000000;  
}
.non-active{
  background:#000000;
  color:#FFFFFF;  
}
.content {
  position: absolute;
  bottom: 23%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100vh;
  width: 100%;
  font-size: 1.7rem;
  text-align:center;
  color:#FFFFFF;
  line-height: 40px;
  font-family:glacial indifference;
  animation: ${fadeText} 1.4s ease-in-out 0s forwards;
}

.footer-button{
  position: absolute;
  bottom: 10%;
  left: 15%;
  display:flex;
  font-family: 'glacial indifference';
  font-size: 1.2rem;
  width: 70%;
  justify-content: space-around;
  color:#FFFFFF;
  animation: ${fadeText} 1.6s ease-in-out 0s forwards;
}

.button-border{
  border: 2px solid #FFFFFF;
  width: 180px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  height: 48px;
  justify-content: center;
}

.bottom_top_anime{
  animation-delay: 1s;
  animation: ${fadeIn} 3s;
}

@media only screen and (max-width: 1799px) and (min-width: 1400px)  {
  .right-side{
    width:60%;
 }
}

@media only screen and (min-width: 1800px) {
  .right-side{
     width:50%;
  }
  .content {
    font-size: 2rem;
  }
  .usage{
    font-size: 1.2rem;

  }
  .footer-button{
    font-size: 1.5rem;
  }
  .plan{
    margin:20px auto;
  }
  .side-button{
    left:-3%;
  }
  .button-border{
    width:200px
  }
}
@media only screen and (min-width: 992px) {
 .redirect-btn{
   display:none
 }
}
.redirect-btn{
  font-family: 'glacial indifference';
}
`;

export const SubmitButton = styled.div`
  cursor:${props => props.disable ? 'not-allowed' : "pointer"} 
  animation: ${fadeIn} 2s;
  color: #000000;
  overflow: hidden;
  position: relative;
  padding: 10px 20px;
  display: flex;
  align-items: center !important;
  justify-content: center;
  height: 50px;
  background:${props => props.org ? "rgb(255, 235, 59)" : "#ffde59"} !important ;
  margin: ${props => props.org ? "50px auto" : "20px auto"};  ;
  border-radius: 15px;
  font-family: 'glacial indifference';
  font-size: 1.2rem;
  font-weight: bold;  
  width:${props => props.org ? "230px" : props.start ? "250px" : "200px"};

  .arrow {
    background: #000;
    height: 2px;
    width: 16px;
    position: relative;
    cursor: pointer;
    transition: 0.2s ease-in-out !important;
    &:before,
    &:after {
      content: '';
      background: #000;
      position: absolute;
      height: 2px;
      width: 12px;
    }

    &:before {
      right: -4px;
      bottom: -4px;
      transform: rotate(-45deg);
    }

    &:after {
      right: -4px;
      top: -4px;
      transform: rotate(45deg);
    }
 
    @media only screen and (min-width: 1460px) {
      height: 2.5px;
      width: 25px;
    }
    @media only screen and (min-width: 2560px) {
      width: 40px;
      &:before {
        width: 20px;
        right: -6px;
        bottom: -6px;
      }
      &:after {
        width: 20px;
        right: -6px;
        top: -6px;
      }
    }
  }
  .wrap-1 {
    position: absolute;
    transform: translatey(0px);
    transition: all 0.5s ease-in-out;
    column-gap: 10px;
    display: flex;
    align-items: center;
  }
   .wrap-2 {
    position: absolute;
    bottom: -85px;    
    box-sizing: border-box;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    column-gap: 10px;
    display: flex;
    align-items: center;
  }

  &:hover > .wrap-2 {
    ${props => !props.disable && ({
    opacity: "1",
    bottom: "25%",
  })
  }}
  &:hover > .wrap-1 {
    ${props => !props.disable && ({
    transform: "translatey(-85px)",
  })
  }}

  &.image-button {
    background: #18012f !important;
    height: 55px;

    &:hover > .wrap-2 {
      opacity: 1;
      bottom: 25%;
    }
    &:hover > .wrap-1 {
      transform: translatey(-50px);
    }
  }

  &.sso-login {
    background: #18012f !important;
    color: #ffffff;

    .arrow {
      background: #ffffff;
      &:before,
      &:after {
        background: #ffffff;
      }
    }
  }
`;

export const OrganisationContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  .ant-row {
    width: 100%;
  }
.left-side{
  height:100vh;
  background-color:rgb(255, 235, 59);
}
.right-side{
  display: flex;
  height:100vh;
  overflow-y:scroll;
}

.organisation-form{
  padding:80px 0px 100px 0px; 
  margin:auto;
  font-family: 'Roboto', sans-serif;
  @media (max-width: 600px) {
    width: 96%;
  }
}
.organization-sign-in-form {
  width: 380px;
  @media (max-width: 600px) {
    width: 96%;
  }
}
.names {
  display: flex;
  column-gap: 8px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
}
.form-container{
  margin:40px auto; 
}
.asterisk{
color:#ff4d4f;
}
@media only screen and (max-width: 1500px) and (min-width: 993px)  {
  .organisation-form{
    padding:80px 0px 100px 0px; 
    margin:auto;
  }
}
@media only screen and (max-width: 992px) {
  .organisation-form{
    padding:80px 0px 100px 0px; 
    margin:auto;
  }
}

@media only screen and (max-width: 778px) {
  .organisation-form{
    padding:80px 0px 100px 0px; 
    margin:auto;
  }
}`

export const ExpiredPage = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 48px;
  row-gap: 80px;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat';
  width: 100%;
  height: 100dvh;
  .expired-message {
    display: flex;
    flex-direction: column;
    row-gap: 12px; 
    text-align: center;
    h1 {
      font-weight: 900;
    }
  }
  svg{
    width: 400px;
  }
`;

export const PayButton = styled.button`
  width: 250px;
  height: 50px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 15px;
  cursor: pointer;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  background-color: white;
  border: 2px solid #ffd23f;
  margin-bottom: 10px;
  color: black;

  &:hover {
    background-color: #fff7e0;
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #f5f5f5;
  }
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;            /* full width */
  margin: 16px 0;
  font-size: 14px;
  color: #888;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #ddd;
  }

  &:not(:empty)::before {
    margin-right: 0.75em;
  }

  &:not(:empty)::after {
    margin-left: 0.75em;
  }
`;